
























import Vue from 'vue';
import { Component, } from 'vue-property-decorator';

@Component
export default class Nav extends Vue {
    get isRouteRecord() {
        return this.$route.path === '/record';
    }

    goOnce() {
        this.$router.push({
            name: 'Once',
            params: {}
        });
    }

    created() {
        return this.isRouteRecord;
    }

}
